<div class="container">
  <h1 class="page-title">
    <span class="icon"><i class="fas fa-truck"></i></span>{{ "BookingHeaderEdit.Header" | translate }}
  </h1>
  <p-card>
    <form class="detail-form">
      <div class="field grid">
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Facility" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.facility | optionsMapping: facilityOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.BookingNum" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.bookingNo | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.BookingStatus" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.bookingStatus | optionsMapping: bookingStatusOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.CarTripNum" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.carTrip | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Forwarder" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.bookingForwarder | optionsMapping: forwarderOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ 'BookingHeaderDetails.Form.AssignTime' | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.tmpAssignDate | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DepartureTime" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.tmpCarSeq | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.VehicleType" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.carType | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.PayeeType" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.carrierPaymentType | optionsMapping: carrierPaymentTypeOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Payee" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.carrierPaymentBy | optionsMapping: forwarderOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Company" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.letterOrgId | optionsMapping: letterHeadOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.BillComp" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.billCorp | optionsMapping: billCorpOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DeliveryType" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.deliveryType | optionsMapping: deliveryTypeOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DeliverySubType" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.deliverSubType | optionsMapping: deliverSubTypeOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Type" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.bookingType | optionsMapping: bookingTypeOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.CustomerCodeName" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.consigneeKey | replaceNullWith: "-" }} - {{ bookingModel?.consigneeCompany | replaceNullWith: "" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.PickUpLocate" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.awbAddress | optionsMapping: pickupLocationOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TradeTerm" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.shipTerm | optionsMapping: incoTermOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.OriginCountry" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.fromCountry | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.OriginCity" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.fromCity | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.OriginArea" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.fromArea | optionsMapping: rfqAreaOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DestiCountry" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.toCountry | optionsMapping: countryOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DestiCity" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.toCity | optionsMapping: cityOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DestiArea" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.toArea | optionsMapping: areaOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalCartonCnt" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalCaseCnt | number | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedCartonCnt" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.updatedTotalCaseCnt | number | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalGrossWeight" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalGrosswgt | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedGrossWeight" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.updatedTotalGrosswgt | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalDim" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalVolumeWeight | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedDim" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.updatedTotalVolumeWeight | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalNetWeight" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalNetWeight | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.FreightCharge" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.airfreightCharge | optionsMapping: chargeOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalQty" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalQty | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.OtherCharge" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.otherCharge | optionsMapping: chargeOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.EstimateCharges" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.estimatedCost | number | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RFQ" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.quotationKey | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DeliveryRemarks" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.remarks | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.NotifyRemark" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.notifyRemarks | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.PaymentType" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.payType | optionsMapping: payTypeOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.PermitNo" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.permitNo | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.AccountID" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.accountId | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.MAWB" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              name="mawb"
              [(ngModel)]="bookingModel.mawb"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.HAWB" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              name="expressBill"
              [(ngModel)]="bookingModel.expressBill"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ExpandField" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.extensionField | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ConsigneeCO" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.coOrgId | optionsMapping: letterHeadOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ShipCorp" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.shipCorp | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Flight1Vehicle1" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              name="flightNo1"
              [(ngModel)]="bookingModel.flightNo1"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">>{{ "BookingHeaderDetails.Form.FlightDate1" | translate }}</label>
          <div class="col-8 column-value">
            <p-calendar
              name="flyDate1"
              [(ngModel)]="bookingModel.flyDate1TimeZone"
              dateFormat="yy/mm/dd"
              dataType="string"
              appendTo="body"
            >
            </p-calendar>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Flight2Vehicle2" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              name="flightNo2"
              [(ngModel)]="bookingModel.flightNo2"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.FlightDate2" | translate }}</label>
          <div class="col-8 column-value">
            <p-calendar
              name="flyDate2"
              [(ngModel)]="bookingModel.flyDate2TimeZone"
              dateFormat="yy/mm/dd"
              dataType="string"
              appendTo="body"
            >
            </p-calendar>
          </div>
        </div>
        <div class="field grid col-12 align-items-baseline">
          <label class="col-2 column-label">{{ 'BookingHeaderDetails.Form.ShippingMethod' | translate }}</label>
          <div class="col-4 column-value">
            {{ bookingModel?.shippingMethod | optionsMapping: shipMethodOptions | replaceNullWith:'-' }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "Common.Label.CreateUser" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.createUser | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "Common.Label.CreateDate" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.createDt | date: "YYYY-MM-dd HH:mm:ss": this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "Common.Label.UpdateUser" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.updateUser | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "Common.Label.UpdateDate" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.updateDt | date: "YYYY-MM-dd HH:mm:ss": this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
          </div>
        </div>
      </div>

      <div class="grid">
        <div class="col">
          <button
            pButton
            pRipple
            label="{{ 'Common.Button.Save' | translate }}"
            class="mr-2"
            (click)="saveBtnClick($event)"
          ></button>
          <button
            pButton
            pRipple
            label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}"
            class="mr-2"
            (click)="goToLastPage()"
          ></button>
        </div>
      </div>
    </form>
  </p-card>
</div>
